export default "https://assets.egbcdn.net/assets/packs/_/sounds/bet_created-7b5aea93226f73001a7206cc95f4bb93.mp3";